import { render } from "./site.vue?vue&type=template&id=06f7342b&ts=true"
import script from "./site.vue?vue&type=script&lang=ts"
export * from "./site.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__